module.exports = __webpack_public_path__ + "static/media/eye.eba5bbc7.png";